<template>
  <section class="component-instructor w-100">
    <div class="panel-card" v-for="item in items" v-if="item">
      <section class="row">
        <div class="col-lg-4 col-md-4 col-sm-6">
          <div class="avatar-instructor">
            <div class="user-avatar">
              <div
                class="user-avatar-inner"
                :style="{ backgroundImage: `url('${appUrl.media}/${item.img}')` }"
              ></div>
            </div>
          </div>
          <div class="instructor-stats">
            <ul class="text-right social">
              <li v-if="item.website">
                <a
                  target="_blank"
                  :href="'http://'+item.website"
                  class="font-16 instructor-stats-value text-info"
                >
                  <span class="font-14" data-balloon-pos="up" data-balloon="وب سایت">
                    <i class="icon-30 flaticon-video"></i>
                  </span>
                </a>
              </li>
              <li v-if="item.twitter">
                <a target="_blank" :href="'https://twitter.com/'+item.twitter">
                  <span class="font-14" data-balloon-pos="up" data-balloon="تویتتر">
                    <i class="icon-30 flaticon-twitter"></i>
                  </span>
                </a>
              </li>
              <li v-if="item.telegram">
                <a target="_blank" :href="'https://t.me/'+item.telegram">
                  <span class="font-14" data-balloon-pos="up" data-balloon="تلگرام">
                    <i class="icon-30 flaticon-telegram"></i>
                  </span>
                </a>
              </li>
              <li v-if="item.instagram">
                <a target="_blank" :href="'https://www.instagram.com/'+item.instagram">
                  <span class="font-14" data-balloon-pos="up" data-balloon="اینستاگرام">
                    <i class="icon-30 flaticon-instagram"></i>
                  </span>
                </a>
              </li>
              <li v-if="item.facebook">
                <a target="_blank" :href="'https://www.linkedin.com/in/'+item.facebook">
                  <span class="font-14" data-balloon-pos="up" data-balloon="لینکدین">
                    <i class="icon-30 flaticon-linkedin"></i>
                  </span>
                </a>
              </li>
            </ul>
            <ul class="rtl text-right my-3">
              <li class="mb-2">
                <span class="font-14 instructor-stats-dec">شغل :</span>
                <span class="font-12 instructor-stats-value">{{item.jobPos}}</span>
              </li>
              <li class="mb-2">
                <span class="font-14 instructor-stats-dec">محل کار :</span>
                <span class="font-12 instructor-stats-value">{{item.workPlace}}</span>
              </li>

              <!-- <li  v-if="item.website">
                                <instructor- class="mdi mdi-star"></i>
                                <span class="font-16 instructor-stats-value text-info">
                                    4.5
                                </span>
                                <span class="font-14 instructor-stats-dec">
                                    میانگین امتیاز ها
                                </span>
                            </li>
                            <li class="mb-2">
                                <i class="mdi mdi-comment-text"></i>
                                <span class="font-12 instructor-stats-value">
                                    7,4645
                                </span>
                                <span class="font-14 instructor-stats-dec">
                                    تعداد بازدید ها
                                </span>
                            </li>
                            <li class="mb-2">
                                <i class="mdi mdi-account"></i>
                                <span class="font-12 instructor-stats-value">
                                    7,4645
                                </span>
                                <span class="font-14 instructor-stats-dec">
                                    دانش آموز
                                </span>
                            </li>
                            <li class="mb-2">
                                <i class="flaticon-play-1-circle-outline"></i>
                                <span class="font-12 instructor-stats-value">
                                    9
                                </span>
                                <span class="font-14 instructor-stats-dec">
                                    آموزش
                                </span>
              </li>-->
            </ul>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-6 text-right rtl">
          <router-link :to="'/user/'+item.user" class="rtl text-right font-18">{{item.fullname}}</router-link>
          <p class="html-box content-html" v-html="item.about"></p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-instructor",
  //   props: ['item'],
  computed: {
    items() {
      if(!this.$store.state.courses.instractor)  return []
      return this.removeDuplicates(this.$store.state.courses.instractor, 'user')
    }
  },
  methods: {
    removeDuplicates(myArr, prop) {
      if (!myArr) return []
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    }
  }
  //   created () {
  //     this.$emit('readyCreator')
  //   }
};
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
.component-instructor {
  .box-clear;
  .avatar-instructor {
    .user-avatar {
      width: 120px;
      height: 120px;
      .border-radius(50%);
      overflow: hidden;
      .user-avatar-inner {
        width: 100%;
        height: 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        border: 1px solid #dedfe0;
      }
    }
  }
  .instructor-stats {
    .box-clear;
    ul {
      li {
        display: block;
        span {
          display: inline-block;
          text-align: right;
          i {
            font-size: 20px;
            margin-left: 5px;
          }
        }
        .instructor-stats-value {
          color: @secondaryTextColor;
        }
        .instructor-stats-dec {
          color: #000;
        }
      }
    }
    .social {
      margin-top: 15px;
      margin-bottom: 0;
      li {
        display: inline-block;
        margin-bottom: 0 !important;
        span {
          color: #000;
        }
        &:hover {
          span {
            color: @secondaryTextColor;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/instructor.vue